const Salary = {
  SalaryDraftToDoHeader: "Salary.SalaryDraftToDoHeader",
  SalaryDraftSelectionHeaderToApprove: "Salary.SalaryDraftSelectionHeaderToApprove",
  SalaryDraftSelectionSubHeader: "Salary.SalaryDraftSelectionSubHeader",
  SalaryDraftTodoDescription: "Salary.SalaryDraftTodoDescription",
  SalaryDraftSelectionHeader: "Salary.SalaryDraftSelectionHeader",
  SalaryDraftCreateSupport: "Salary.SalaryDraftCreateSupport",
  SalaryDraftRejectFormMessage: "Salary.SalaryDraftRejectFormMessage",
  SalaryDraftRejectSuccessMessage: "Salary.SalaryDraftRejectSuccessMessage",
  SalaryDraftReceiver: "Salary.SalaryDraftReceiver",
  SalaryDraftReceiverHelpText: "Salary.SalaryDraftReceiverHelpText",
  SalaryDraftAssignSuccessMessage: "Salary.SalaryDraftAssignSuccessMessage",
  SalaryDraftAcceptSuccessMessage: "Salary.SalaryDraftAcceptSuccessMessage",
  SeeDeviationReport: "Salary.SeeDeviationReport",
  Tax: "Salary.Tax",
  Taxes: "Salary.Taxes",
  NetSalary: "Salary.NetSalary",
  Benefit: "Salary.Benefit",
  Salaries: "Salary.Salaries",
  EmployerContribution: "Salary.EmployerContribution",
  GoToSalaryReport: "Salary.GoToSalaryReport",
  TodoSelectionPanelTitle: "Salary.TodoSelectionPanelTitle",
  TodoSelectionPanelSubTitle: "Salary.TodoSelectionPanelSubTitle",
  TodoSelectionPanelSubTitleSalaryAuto: "Salary.TodoSelectionPanelSubTitleSalaryAuto",
  WantToChangeAnything: "Salary.WantToChangeAnything",
  ChangeSalaries: "Salary.ChangeSalaries",
  SocialSecurityAndSalaries: "Salary.SocialSecurityAndSalaries",
  SocialFees: "Salary.SocialFees",
  MonthlySalaries: "Salary.MonthlySalaries",
  SalaryWarningForLargeSalaries: "Salary.SalaryWarningForLargeSalaries",
  SubmitSuccessMessage: "Salary.SubmitSuccessMessage",
  PersonSalaryViewState_0: "Salary.PersonSalaryViewState_0",
  PersonSalaryViewState_1: "Salary.PersonSalaryViewState_1",
  PersonSalaryViewState_2: "Salary.PersonSalaryViewState_2",
  PersonSalaryViewState_3: "Salary.PersonSalaryViewState_3",
  PersonSalaryViewState_4: "Salary.PersonSalaryViewState_4",
  TaxesAndFees: "Salary.TaxesAndFees",
  Benefits: "Salary.Benefits",
  BenefitAmount: "Salary.BenefitAmount",
  BenefitNetDeduction: "Salary.BenefitNetDeduction",
  BenefitGrossSalaryIncrease: "Salary.BenefitGrossSalaryIncrease",
  GrossSalary: "Salary.GrossSalary",
  TaxableAmount: "Salary.TaxableAmount",
  Salary: "Salary.Salary",
  SalarySpecification: "Salary.SalarySpecification",
  SalarySpecifications: "Salary.SalarySpecifications",
  SalaryReportMonthLastDate: "Salary.SalaryReportMonthLastDate",
  PreliminarySettlement: "Salary.PreliminarySettlement",
  SomethingWentWrongWithSalaryRows: "Salary.SomethingWentWrongWithSalaryRows",
  MonthlySalary: "Salary.MonthlySalary",
  ActiveSalary: "Salary.ActiveSalary",
  ActiveSalaryDescription: "Salary.ActiveSalaryDescription",
  SalaryDraftTitle: "Salary.SalaryDraftTitle",
  SalaryDraftState_0: "Salary.SalaryDraftState_0",
  SalaryDraftState_1: "Salary.SalaryDraftState_1",
  SalaryDraftState_2: "Salary.SalaryDraftState_2",
  SalaryDraftState_3: "Salary.SalaryDraftState_3",
  SalaryDraftState_4: "Salary.SalaryDraftState_4",
  SalaryDraftState_5: "Salary.SalaryDraftState_5",
  EditSalary: "Salary.EditSalary",
  HighSalaryWarningHeader: "Salary.HighSalaryWarningHeader",
  HighSalaryWarningDescription: "Salary.HighSalaryWarningDescription",
  Close: "Salary.Close",
  SalaryDraftSubHeaderDescription: "Salary.SalaryDraftSubHeaderDescription",
  AddExtraSalary: "Salary.AddExtraSalary",
  AddExtraSalaryTitle: "Salary.AddExtraSalaryTitle",
  AddExtraSalaryDescription: "Salary.AddExtraSalaryDescription",
  AddExtraSalaryEmployee: "Salary.AddExtraSalaryEmployee",
  AddExtraSalaryAmountToBePaid: "Salary.AddExtraSalaryAmountToBePaid",
  AddExtraSalaryAmountToBePaidDescription: "Salary.AddExtraSalaryAmountToBePaidDescription",
  AddExtraSalaryPaymentDate: "Salary.AddExtraSalaryPaymentDate",
  DownloadSpecification: "Salary.DownloadSpecification",
  TotalGrossSalary: "Salary.TotalGrossSalary",
  TotalTax: "Salary.TotalTax",
  TaxOnExtraSalary: "Salary.TaxOnExtraSalary",
  NetSalaryForExtraSalary: "Salary.NetSalaryForExtraSalary",
  SalaryDetailInfoMessage: "Salary.SalaryDetailInfoMessage",
  WintTodoHeader: "Salary.WintTodoHeader",
  WintTodoHeaderCustomerPaysOut: "Salary.WintTodoHeaderCustomerPaysOut",
  WintTodoDescription: "Salary.WintTodoDescription",
  WintTodoDescriptionCustomerPaysOut: "Salary.WintTodoDescriptionCustomerPaysOut",
  WintSalaryState_0: "Salary.WintSalaryState_0",
  WintSalaryState_1: "Salary.WintSalaryState_1",
  WintSalaryState_2: "Salary.WintSalaryState_2",
  WintSalaryState_3: "Salary.WintSalaryState_3",
  WintSalaryState_4: "Salary.WintSalaryState_4",
  WintSalaryState_5: "Salary.WintSalaryState_5",
  SalaryPaymentState_0: "Salary.SalaryPaymentState_0",
  SalaryPaymentState_1: "Salary.SalaryPaymentState_1",
  SalaryPaymentState_2: "Salary.SalaryPaymentState_2",
  SalaryPaymentState_3: "Salary.SalaryPaymentState_3",
  SalaryPaymentState_4: "Salary.SalaryPaymentState_4",
  SalaryPaymentState_5: "Salary.SalaryPaymentState_5",
  SalaryPaymentState_6: "Salary.SalaryPaymentState_6",
  SalaryPaymentState_7: "Salary.SalaryPaymentState_7",
  SalaryPaymentState_8: "Salary.SalaryPaymentState_8",
  SalaryPaymentState_9: "Salary.SalaryPaymentState_9",
  WintSalaryPaymentStateColumnHeader: "Salary.WintSalaryPaymentStateColumnHeader",
  ViewPayslip: "Salary.ViewPayslip",
  GrossSalaryChangeFormTitle: "Salary.GrossSalaryChangeFormTitle",
  GrossSalaryChangeLabel: "Salary.GrossSalaryChangeLabel",
  GrossSalaryChangeDescription: "Salary.GrossSalaryChangeDescription",
  GrossSalaryChangeInfoText: "Salary.GrossSalaryChangeInfoText",
  GrossSalaryChangeSuccess: "Salary.GrossSalaryChangeSuccess",
  GrossSalaryChangeResultLabel: "Salary.GrossSalaryChangeResultLabel",
  GrossSalaryChangeResultTotalCostForCompany: "Salary.GrossSalaryChangeResultTotalCostForCompany",
  GrossSalaryChangeResultRemainingNetAmount: "Salary.GrossSalaryChangeResultRemainingNetAmount",
  GrossSalaryChangeResultAlreadyPaidOutNetAmount: "Salary.GrossSalaryChangeResultAlreadyPaidOutNetAmount",
  GrossSalaryChangeResultSocialFees: "Salary.GrossSalaryChangeResultSocialFees",
  GrossSalaryChangeResultTaxCost: "Salary.GrossSalaryChangeResultTaxCost",
  GrossSalaryChangeRecalculateTooltip: "Salary.GrossSalaryChangeRecalculateTooltip",
  GrossSalaryChangeMinFloorAccordionTitle: "Salary.GrossSalaryChangeMinFloorAccordionTitle",
  GrossSalaryChangeFillMinButton: "Salary.GrossSalaryChangeFillMinButton",
  GrossSalaryChangeFillMinButtonWithAmount: "Salary.GrossSalaryChangeFillMinButtonWithAmount",
  GrossSalaryChangeFloorBannerWithPaidNet: "Salary.GrossSalaryChangeFloorBannerWithPaidNet",
  GrossSalaryChangeFloorBannerWithoutPaidNet: "Salary.GrossSalaryChangeFloorBannerWithoutPaidNet",
  ZeroGrossSalaryChangeDialogTitle: "Salary.ZeroGrossSalaryChangeDialogTitle",
  ZeroGrossSalaryChangeDialogDescription: "Salary.ZeroGrossSalaryChangeDialogDescription",
  ZeroGrossSalaryChangeDialogSuccessMessage: "Salary.ZeroGrossSalaryChangeDialogSuccessMessage",
  ZeroGrossSalaryChangeDialogResetSalary: "Salary.ZeroGrossSalaryChangeDialogResetSalary",
  ZeroGrossSalaryChangeDialogResetSalaryError: "Salary.ZeroGrossSalaryChangeDialogResetSalaryError",
  TotalSalaryChartTitle: "Salary.TotalSalaryChartTitle",
  GrossSalaryChartTitle: "Salary.GrossSalaryChartTitle",
  GrossSalaryChartAdditionalDataTitle_1: "Salary.GrossSalaryChartAdditionalDataTitle_1",
  GrossSalaryChartAdditionalDataTitle_2: "Salary.GrossSalaryChartAdditionalDataTitle_2",
  PreviousMonth: "Salary.PreviousMonth",
  ChangeGrossSalaryTaxTypeLabel: "Salary.ChangeGrossSalaryTaxTypeLabel",
  ChangeGrossSalaryTaxTypeDescription: "Salary.ChangeGrossSalaryTaxTypeDescription",
  ChangeGrossSalaryTaxType_0: "Salary.ChangeGrossSalaryTaxType_0",
  ChangeGrossSalaryTaxType_1: "Salary.ChangeGrossSalaryTaxType_1",
  NetSalaryToBePaid: "Salary.NetSalaryToBePaid",
  PaymentDateDescription: "Salary.PaymentDateDescription",
  ExtraPayoutTitle: "Salary.ExtraPayoutTitle",
  ExtraPayoutCreateButtonText: "Salary.ExtraPayoutCreateButtonText",
  NewGrossSalaryAmount: "Salary.NewGrossSalaryAmount",
  ExtraPayoutPreviewGrossSalaryTitle: "Salary.ExtraPayoutPreviewGrossSalaryTitle",
  ExtraPayoutPreviewCompanyCostTitle: "Salary.ExtraPayoutPreviewCompanyCostTitle",
  ExtraPayoutPreviewGrossSalaryMonthlySalary: "Salary.ExtraPayoutPreviewGrossSalaryMonthlySalary",
  ExtraPayoutPreviewGrossSalaryDeviation: "Salary.ExtraPayoutPreviewGrossSalaryDeviation",
  ExtraPayoutPreviewGrossSalarySalaryAdjustments: "Salary.ExtraPayoutPreviewGrossSalarySalaryAdjustments",
  ExtraPayoutPreviewGrossSalaryBenefits: "Salary.ExtraPayoutPreviewGrossSalaryBenefits",
  ExtraPayoutPreviewCompanyCostRemainingNetSalary: "Salary.ExtraPayoutPreviewCompanyCostRemainingNetSalary",
  ExtraPayoutPreviewCompanyCostAllExtraSalaries: "Salary.ExtraPayoutPreviewCompanyCostAllExtraSalaries",
  ExtraPayoutPreviewCompanyCostSocialFees: "Salary.ExtraPayoutPreviewCompanyCostSocialFees",
  ExtraPayoutPreviewCompanyCostTaxCost: "Salary.ExtraPayoutPreviewCompanyCostTaxCost",
  ExtraPayoutSubmitSuccess: "Salary.ExtraPayoutSubmitSuccess",
  ExtraPayoutMenuItemText: "Salary.ExtraPayoutMenuItemText",
  ExtraPayoutListTitle: "Salary.ExtraPayoutListTitle",
  ExtraPayoutListStatusNew: "Salary.ExtraPayoutListStatusNew",
  ExtraPayoutListStatusRejectedByPaymentService: "Salary.ExtraPayoutListStatusRejectedByPaymentService",
  ExtraPayoutListStatusReceivedByPaymentService: "Salary.ExtraPayoutListStatusReceivedByPaymentService",
  ExtraPayoutListStatusWaitingToBeSigned: "Salary.ExtraPayoutListStatusWaitingToBeSigned",
  ExtraPayoutListStatusWaitingToBeSent: "Salary.ExtraPayoutListStatusWaitingToBeSent",
  ExtraPayoutListStatusSent: "Salary.ExtraPayoutListStatusSent",
  ExtraPayoutListStatusVerified: "Salary.ExtraPayoutListStatusVerified",
  ExtraPayoutListStatusStopped: "Salary.ExtraPayoutListStatusStopped",
  ExtraPayoutListStatusRejected: "Salary.ExtraPayoutListStatusRejected",
  ExtraPayoutListStatusPending: "Salary.ExtraPayoutListStatusPending",
  ExtraPayoutListStatusRemoved: "Salary.ExtraPayoutListStatusRemoved",
  ExtraPayoutListStatusPayoutDateTooCloseInTime: "Salary.ExtraPayoutListStatusPayoutDateTooCloseInTime",
  ExtraPayoutListStatusError: "Salary.ExtraPayoutListStatusError",
  ExtraPayoutListStatusUnknown: "Salary.ExtraPayoutListStatusUnknown",
  ExtraPayoutListTooltip: "Salary.ExtraPayoutListTooltip",
  ExtraPayoutMinimumPayoutAmount: "Salary.ExtraPayoutMinimumPayoutAmount",
  ExtraPayoutAmountTypeLabel: "Salary.ExtraPayoutAmountTypeLabel",
  ExtraPayoutAmountTypeNet: "Salary.ExtraPayoutAmountTypeNet",
  ExtraPayoutAmountTypeGross: "Salary.ExtraPayoutAmountTypeGross",
  ExtraPayoutNetSalaryToBePaid: "Salary.ExtraPayoutNetSalaryToBePaid",
  ExtraPayoutGrossSalaryToBePaid: "Salary.ExtraPayoutGrossSalaryToBePaid",
  ExtraPayoutPayoutTypeLabel: "Salary.ExtraPayoutPayoutTypeLabel",
  ExtraPayoutPayoutTypeExtra: "Salary.ExtraPayoutPayoutTypeExtra",
  ExtraPayoutPayoutTypeAdvance: "Salary.ExtraPayoutPayoutTypeAdvance",
  ExtraPayoutPaymentsLabel: "Salary.ExtraPayoutPaymentsLabel",
  ExtraPayoutResultLabel: "Salary.ExtraPayoutResultLabel",
  ExtraPayoutProposedPayoutRow: "Salary.ExtraPayoutProposedPayoutRow",
  ExtraPayoutRemainingNetRow: "Salary.ExtraPayoutRemainingNetRow",
  ExtraPayoutExceedsAvailableInfo: "Salary.ExtraPayoutExceedsAvailableInfo",
  ExtraPayoutTaxTypeLabel: "Salary.ExtraPayoutTaxTypeLabel",
  }
export default Salary;